import API from '..';

const getRandomPassword = () =>
    API.get('api/v1/random-password/?very_difficult=yes&length=20');

export default getRandomPassword;
